import { CartografiaService } from 'src/app/services/SiicartAdm/cartografia.service';
import { ConfigService } from 'src/config/config.service';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import * as AdmCartoActions from '../../../actions/';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { ThrowStmt } from '@angular/compiler';
import { AppState } from 'src/app/store/app.reducer';
import { Store } from '@ngrx/store';
import { MainLoadActive, MainLoadDeactive } from '../../../actions/shared/mainLoad.action';

@Injectable()
export class admCartoEffects {

    constructor(
        private actions$: Actions,
        private cartoAdmService: CartografiaService,
        private config: ConfigService,
        private router: Router,
        private store: Store<AppState>
    ) { }

    // effects go here
    @Effect()
    AdmGetCarto$: Observable<any> = this.actions$.pipe(
        ofType(AdmCartoActions.AdmCartoActionTypes.GET_ADM_CARTO),
        switchMap((action: AdmCartoActions.AdmGetCarto) => {
            return this.cartoAdmService.ObtenerCarto()
                .pipe(
                    map((resultado: any) => {
                        return new AdmCartoActions.AdmSuscessCarto(resultado, 'ListCarto');
                    }),
                    catchError(error => of(new AdmCartoActions.AdmFailCarto({ error })))
                );
        }
        )
    );

    @Effect()
    AdmSetCarto$: Observable<any> = this.actions$.pipe(
        ofType(AdmCartoActions.AdmCartoActionTypes.SET_ADM_CARTO),
        switchMap((action: AdmCartoActions.AdmSetCarto) => {
            return this.cartoAdmService.AgrModfCarto(action.DatosCarto)
                .pipe(
                    map((resultado: any) => {
                        return new AdmCartoActions.AdmSuscessCarto(resultado, 'SetCarto');
                        //return new AdmCartoActions.AdmGetCarto();
                    }),
                    catchError(error => of(new AdmCartoActions.AdmFailCarto({ error })))
                );
        }
        )
    );

    @Effect()
    AdmDeleteCarto$: Observable<any> = this.actions$.pipe(
        ofType(AdmCartoActions.AdmCartoActionTypes.DELETE_ADM_CARTO),
        switchMap((action: AdmCartoActions.AdmDeleteCarto) => {
            return this.cartoAdmService.EliminarCarto(action.ObjDel)
                .pipe(
                    map((resultado: any) => {
                        return new AdmCartoActions.AdmSuscessCarto(resultado, 'DeleteCarto');
                        //return new AdmCartoActions.AdmGetCarto();
                    }),
                    catchError(error => of(new AdmCartoActions.AdmFailCarto({ error })))
                );
        }
        )
    );
}
